import React, { useEffect, useState } from "react"
import "./styles.scss"
import DashboardNavbar from "../../components/Navbar/DashboardNavbar"
import { Slider } from "@material-ui/core"
import { useParams } from "react-router"
import FullLoader from "../../components/Loaders/FullLoader"
import {
  deleteProductFromRegistry,
  getRegistryById,
  updateRegistryImages
} from "../../utils/ApiRequests"
import { AiOutlineClose } from "react-icons/ai"
import { getApiErrorMessage } from "../../utils/ApiUtils"
import AdminRegistryItemView from "../../components/ItemPreview/AdminRegistryItemView"
import { useToasts } from "react-toast-notifications"
import AddProductToRegistry from "../../components/AddProduct/AddProductToRegistry"
import editIcon from "../../assets/registry-edit.svg"
import ModalContainer from "../../components/ModalContainer/ModalContainer"
import { Link, useHistory } from "react-router-dom"
import CustomRegistryItemView from "../../components/ItemPreview/CustomItemRegistryView"

const AdminRegistry = () => {
  const { id } = useParams()
  const [loading, setLoading] = useState(true)
  const [data, setData] = useState({})
  const [filterProducts, setFilterProducts] = useState([])
  const { addToast } = useToasts()
  const [itemsModal, setItemsModals] = useState(false)
  const [editModal, setEditModal] = useState(false)
  const [imageForm, setImageForm] = useState({})
  const history = useHistory()

  useEffect(() => {
    getRegistryById(id)
      .then(res => {
        // console.log(res.data?.data)
        setData(res.data?.data)
        setLoading(false)
        setFilterProducts(res.data.data?.products)
      })
      .catch(err => {
        console.log(getApiErrorMessage(err))
        setLoading(false)
      })
  }, [id, itemsModal, loading])

  const {
    header_image,
    subheader_images,
    slug,
    name,
    products,
    minProductPrice,
    maxProductPrice,
    categories,
    contributions
  } = data

  const [priceValue, setPriceValue] = useState([
    minProductPrice,
    maxProductPrice
  ])
  useEffect(() => {
    setFilterProducts(products)
    setPriceValue([minProductPrice, maxProductPrice])
  }, [products, minProductPrice, maxProductPrice])

  const handleValueChange = (event, newValue) => {
    setPriceValue(newValue)
    setFilterProducts(
      products.filter(
        p =>
          p.product.sales_price >= newValue[0] &&
          p.product.sales_price <= newValue[1]
      )
    )
  }

  const handleImageChange = e => {
    const img = e.target.files[0]
    const name = e.target.name
    const newEntry = { [name]: img }
    setImageForm({ ...imageForm, ...newEntry })
  }

  const DeleteProduct = productId => {
    setLoading(true)
    deleteProductFromRegistry(id, productId)
      .then(res => {
        setLoading(false)
        addToast(res.data.message, {
          appearance: "success",
          autoDismiss: true
        })
      })
      .catch(err => {
        setLoading(false)
        addToast(getApiErrorMessage(err.response), {
          appearance: "error",
          autoDismiss: true
        })
      })
  }

  const updateImages = e => {
    setLoading(true)
    setEditModal(false)
    e.preventDefault()
    const fileData = new FormData()
    fileData.append("header", imageForm.p1)
    fileData.append("subheaders", imageForm.p2)
    fileData.append("subheaders", imageForm.p3)

    updateRegistryImages(id, fileData)
      .then(res => {
        addToast(res.data.message, { appearance: "success" })
      })
      .catch(err =>
        addToast(getApiErrorMessage(err.response), { appearance: "error" })
      )
      .finally(() => {
        setLoading(false)
        history.go(0)
      })
  }

  return (
    <>
      <DashboardNavbar />

      {loading && <FullLoader />}

      {itemsModal && (
        <AddProductToRegistry
          registryId={id}
          closeModal={() => setItemsModals()}
        />
      )}

      {editModal && (
        <ModalContainer>
          <form
            className="w-96 bg-white p-5"
            style={{ height: "470px" }}
            onSubmit={updateImages}
          >
            <AiOutlineClose
              className="text-3xl font-bold ml-auto mb-3 cursor-pointer"
              onClick={() => setEditModal(false)}
            />
            <h2 className="text-center text-sbg-grey text-xl mb-3">
              Update header images
            </h2>

            <div className="w-11/12 mx-auto">
              <h3 className="text-sbg-grey text-lg mb-2">Header 1</h3>
              <input
                type="file"
                accept="image/"
                className="bg-gray-200 block w-full  py-3 px-6 my-2"
                name="p1"
                onChange={handleImageChange}
              />
            </div>

            <div className="w-11/12 mx-auto">
              <h3 className="text-sbg-grey text-lg mb-2">Header 2</h3>
              <input
                type="file"
                accept="image/"
                className="bg-gray-200 block w-full  py-3 px-6 my-2"
                name="p2"
                onChange={handleImageChange}
              />
            </div>

            <div className="w-11/12 mx-auto">
              <h3 className="text-sbg-grey text-lg mb-2">Header 3</h3>
              <input
                type="file"
                accept="image/"
                className="bg-gray-200 block w-full  py-3 px-6 my-2"
                name="p3"
                onChange={handleImageChange}
              />
            </div>

            <button
              type="submit"
              className="mx-auto px-5 block py-2 text-center text-white bg-sbg-light-green font-medium text-base focus:outline-none my-5"
            >
              Update Images
            </button>
          </form>
        </ModalContainer>
      )}

      <Link
        className="flex justify-end items-center mt-32 global-container ml-auto pr-10"
        to={`/gift/registry/${slug}`}
      >
        <img
          src={require("../../assets/preview.svg").default}
          alt="settings"
          className=" mr-2 h-5"
        />
        <p className="text-lg text-sbg-grey">Preview registry</p>
      </Link>

      {!loading && (
        <div className="registry__page-wrapper py-10 global-container">
          <div className="flex flex-wrap ">
            <div className="mobiles:w-full w-2/5 lg:w-1/2 px-3 mb-4">
              <div className="registry__bannerImg relative ">
                <img
                  src={header_image}
                  alt="lg_img"
                  className="h-50vh object-center "
                />

                <div
                  className="absolute top-2 right-2 h-14 w-14 cursor-pointer"
                  onClick={() => setEditModal(true)}
                >
                  <img src={editIcon} alt="edit-icon" className="" />
                </div>
              </div>
            </div>
            <div className="mobiles:w-full mobiles:px-2 w-3/5 lg:w-1/2 px-5 mb-4">
              <div className="registry__header-card shadow text-center px-10 py-5 rounded-md ">
                <h5 className="text-center font-bold">YOUR REGISTRY URL</h5>
                <input
                  className="font-thin block w-full mx-auto text-center focus:outline-none"
                  id="copy-text"
                  value={`${window.location.origin}/gift/registry/${slug}`}
                  readOnly={true}
                />

                <button
                  className="mt-3 px-3 py-1 focus:outline-none rounded-lg"
                  style={{ background: "#95D6A4", color: "white" }}
                  onClick={() => {
                    var copyText = document.getElementById("copy-text")
                    copyText.focus()
                    copyText.select()
                    copyText.setSelectionRange(0, 99999)
                    document.execCommand("copy")
                  }}
                >
                  Copy
                </button>
              </div>
              <div
                className="registry__name-card my-5  rounded-md  text-center text-5xl"
                style={{ background: "#95D6A4", color: "white" }}
              >
                <div className="relative py-10 px-5">
                  <p>
                    <b>{name}</b>
                  </p>
                  {/* <img
                  src={editIcon}
                  alt="edit-icon"
                  className="registry_edit_icon -edit_name"
                /> */}
                </div>
              </div>
              <div className="registry__welcome text-center my-7">
                {/* <h3 className="text-2xl mb-3 font-bold">
                Welcome to our registry
              </h3> */}
                {/* <p>
                My night has become a sunny dawn because of you. No matter how
                dark your day is..... Jidenna
              </p> */}
              </div>
              <div className="flex my-4">
                <div className="w-1/3 p-3">
                  <img
                    src={header_image}
                    alt="img_sm"
                    className="h-20vh object-center w-full rounded-lg"
                  />
                </div>
                <div className="w-1/3 p-3">
                  <img
                    src={
                      subheader_images?.length
                        ? subheader_images[0]
                        : header_image
                    }
                    alt="img_sm"
                    className="h-20vh object-center w-full rounded-lg"
                  />
                </div>
                <div className="w-1/3 p-3">
                  <img
                    src={
                      subheader_images?.length
                        ? subheader_images[1]
                        : header_image
                    }
                    alt="img_sm"
                    className="h-20vh object-center w-full rounded-lg"
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="w-full border-2 border-dashed rounded-xl py-4 text-center my-5">
            <img
              src={require("../../assets/add-item.svg").default}
              className="h-14 mx-auto cursor-pointer"
              alt="add item"
              onClick={() => setItemsModals(true)}
            />

            <h2 className="text-center mt-2">Add Gifts</h2>
          </div>

          <section className="flex">
            <div className="w-60 mobiles:hidden self-start p-5 mr-8 shadow rounded-md">
              <div className="py-4 border-b-2 border-gray-200 mb-2">
                <p className="text-gray-600">Multi Range</p>
                <div className="flex justify-between w-full mt-3 mb-6">
                  <h2 className="text-gray-600 text-xs">{minProductPrice}</h2>
                  <h2 className="text-gray-600 text-xs">{maxProductPrice}</h2>
                </div>

                <Slider
                  valueLabelDisplay="auto"
                  classes={{
                    root: "slider-root",
                    thumb: "slider-thumb",
                    valueLabel: "slider-value-label",
                    track: "slider-track",
                    rail: "slider-rail"
                  }}
                  value={priceValue}
                  min={minProductPrice}
                  max={maxProductPrice}
                  onChange={handleValueChange}
                />
              </div>

              {categories.map((c, i) => (
                <div
                  className="flex w-full items-center justify-between mb-2"
                  key={i}
                >
                  <input
                    type="radio"
                    className="w-1/12"
                    name="category"
                    onChange={() =>
                      setFilterProducts(
                        products.filter(p => p.product?.category[0] === c._id)
                      )
                    }
                  />
                  <p className="w-10/12 text-sm text-gray-500">{c.name}</p>
                </div>
              ))}

              <div className="mt-5">
                <button
                  style={{ backgroundColor: "#6F64F8", fontSize: "11px" }}
                  className="px-3 block py-3 w-full text-center text-white rounded-bl-md"
                  onClick={() => setFilterProducts(products)}
                >
                  CLEAR ALL FILTERS
                </button>
              </div>
            </div>
            <div className="flex-1 mobiles:w-full mobiles:grid-cols-2 mobiles:gap-4 grid grid-cols-3 gap-10">
              {contributions?.map((c, i) => (
                <CustomRegistryItemView {...c} key={i} />
              ))}
              {!!products &&
                filterProducts?.map((product, i) => (
                  <AdminRegistryItemView
                    product={product}
                    key={i}
                    // registryId={registryId}
                    handleDelete={() => DeleteProduct(product?.product._id)}
                  />
                ))}
            </div>
          </section>
        </div>
      )}
    </>
  )
}
export default AdminRegistry
